// material-ui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function Footer() {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'center', p: '24px 16px 0px', mt: 'auto' }}
    >
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        &copy; {new Date().getFullYear()} Apartman Yönetim Sistemi — Tüm hakları saklıdır.
      </Typography>
    </Stack>
  );
}
